module.exports = __webpack_public_path__ + "static/img/item2.9bdc227.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/teacher/item2.png
// module id = L9m4
// module chunks = 63